import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export type RemoveSavedSearchCall = (
  userId: number,
  searchId: number,
) => Promise<{ data: {} }>;

export default (makeCall: MakeCall) => (userId: number, searchId: number) =>
  makeCall<{}>('DELETE', `${APIV2_URL}/user/${userId}/search/${searchId}`);
